import { Phase } from "@/pages/heat-report/models/HeatReportModels";
import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Phases",
			children: [
				{
					field: "PhaseName",
					headerName: "Phase Name",
					flex: 2,
					minWidth: 125,
				},
				{
					field: "Start",
					headerName: "Start",
					flex: 1,
					minWidth: 82,
					valueGetter: (params: any) => {
						if (params.data.Start) {
							return moment((params.data as Phase).Start).format("HH:mm:ss");
						}
					},
				},
				{
					field: "End",
					headerName: "End",
					flex: 1,
					minWidth: 82,
					valueGetter: (params: any) => {
						if (params.data.End) {
							return moment((params.data as Phase).End).format("HH:mm:ss");
						}
					},
				},
				{
					field: "Duration",
					headerName: "Duration",
					flex: 1,
					minWidth: 76,
					valueGetter: (params: any) => {
						const { Start, End } = params.data as Phase;

						if (End && Start) {
							const durationInSeconds = moment(End).diff(
								moment(Start),
								"seconds",
							);
							const minutes = Math.floor(durationInSeconds / 60);
							const seconds = durationInSeconds % 60;
							return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
						}
					},
				},
				{
					field: "Energy",
					headerName: "Energy [kwh]",
					flex: 1,
					wrapHeaderText: true,
					headerStyle: {
						textAlign: "center",
					},
					minWidth: 60,
					valueGetter: (params: any) => {
						const energy = (params.data as Phase).Energy;
						return energy || " ";
					},
				},
			],
		},
	];

	return { columns };
};
